import WatchlistTable from './components/WatchlistTable';

export { TableTitle } from './components/TableTitle';
export {
  DeprecatedTableActions,
  TableActions,
} from './components/TableActions';

export default WatchlistTable;
